import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TaskbookService } from "../../taskbook-triage/taskbook.service";
import { Task, TaskAction } from "../../taskbook-triage/taskbook.types";

@Component({
    selector: 'task-detail-actions',
    templateUrl: './task-detail-actions.component.html',
    styleUrls: ['./task-detail-actions.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
    ]
})
export class TaskDetailActionsComponent implements OnChanges{

    taskActions: TaskAction[]

    @Input() task: Task;

    @Output() onAction = new EventEmitter<{ task: Task, action: TaskAction }>()

    constructor(
        private taskbookService: TaskbookService
    ){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.task){
            this.taskActions = this.taskbookService.getDetailActionsByTaskType(this.task);
        }
    }

    action(task: Task, action: TaskAction){
        this.onAction.emit({ task: task, action: action })
    }

}
